import { z } from 'zod';
export const TIPOS_CLASE = ['PRIVADA', 'GRUPAL', 'EMPRESA'];
export const METODOS_PAGO = ['EFECTIVO', 'TARJETA', 'TRANSFERENCIA', 'MERCADOPAGO'];
export const ESTADOS_RESERVA = ['SOLICITADA', 'CONFIRMADA', 'CANCELADA', 'FINALIZADA'];
export const ESTADOS_CLASE = [
    'PROGRAMADA',
    'ASIGNADA',
    'DICTADA',
    'CANCELADA',
];
export const ComisionSolicitadoSchema = z.object({
    modo: z.string().nullable().optional(),
    pct: z.string().nullable().optional(),
    monto: z.string().nullable().optional(),
});
export const InscripcionSchema = z.object({
    id: z.string().uuid(),
    claseId: z.string().uuid(),
    fechaHoraInicio: z.string(),
    duracionHoras: z.number(),
    cantPersonas: z.number(),
    montoFacturado: z.coerce.number(),
    estado: z.string(),
    claseEstado: z.string(),
    empleadoId: z.string().uuid().nullable().optional(),
    empleadoNombre: z.string().nullable().optional(),
    tipoClase: z.string().nullable().optional(),
    disciplina: z.string().nullable().optional(),
});
export const ClasesResumenSchema = z.object({
    conInstructor: z.number(),
    sinInstructor: z.number(),
    canceladas: z.number(),
    total: z.number(),
});
export const ReservaSchema = z.object({
    id: z.string().uuid(),
    codigo: z.string(),
    clienteId: z.string().uuid(),
    clienteNombre: z.string().nullable().optional(),
    sucursalId: z.string().uuid(),
    clasesResumen: ClasesResumenSchema.optional(),
    promotorId: z.string().uuid().nullable().optional(),
    empleadoSolicitadoId: z.string().uuid().nullable().optional(),
    metodoPagoPrevisto: z.string(),
    estado: z.enum(ESTADOS_RESERVA),
    canal: z.string().nullable().optional(),
    observaciones: z.string().nullable().optional(),
    // Para promotor externo el backend omite montos en el listado (sólo
    // los vuelve a exponer en el detalle). Los marcamos opcionales.
    totalBruto: z.coerce.number().optional(),
    totalDescuentos: z.coerce.number().optional(),
    totalNeto: z.coerce.number().optional(),
    paga: z.boolean().optional(),
    fechaPagaTotal: z.string().nullable().optional(),
    pasarelaPaga: z
        .object({
        clave: z.string(),
        etiqueta: z.string(),
    })
        .nullable()
        .optional(),
    totalPagado: z.union([z.string(), z.number()]).optional(),
    pagoEstado: z.enum(['pagado', 'parcial', 'pendiente']).optional(),
    claseDestacada: z
        .object({
        fechaHoraInicio: z.string(),
        tipoClase: z.string().nullable().optional(),
        disciplina: z.string().nullable().optional(),
    })
        .nullable()
        .optional(),
    comisionPctBase: z.union([z.string(), z.number()]).nullable().optional(),
    comisionPctEfectiva: z.union([z.string(), z.number()]).nullable().optional(),
    /** Comisión estimada pre-calculada por el backend en el listado del promotor. */
    comisionEstimada: z.union([z.string(), z.number()]).nullable().optional(),
    comisionSolicitado: ComisionSolicitadoSchema.optional(),
    fechaCancelacion: z.string().nullable().optional(),
    motivoCancelacion: z.string().nullable().optional(),
    creadoEn: z.string(),
    creadoPor: z
        .object({
        id: z.string().uuid(),
        nombre: z.string().nullable(),
        email: z.string().nullable(),
    })
        .nullable()
        .optional(),
    actualizadoEn: z.string(),
    actualizadoPor: z
        .object({
        id: z.string().uuid(),
        nombre: z.string().nullable(),
        email: z.string().nullable(),
    })
        .nullable()
        .optional(),
    inscripciones: z.array(InscripcionSchema).optional(),
});
export const PaginacionSchema = z.object({
    total: z.number(),
    pagina: z.number(),
    porPagina: z.number(),
    totalPaginas: z.number(),
});
export const ReservasPaginadasSchema = z.object({
    items: z.array(ReservaSchema),
    paginacion: PaginacionSchema,
});
export const NuevaReservaSchema = z.object({
    clienteId: z.string().uuid('Seleccioná un cliente'),
    sucursalId: z.string().uuid('Seleccioná una sucursal'),
    promotorId: z.string().uuid().optional().or(z.literal('')),
    empleadoSolicitadoId: z.string().uuid().optional().or(z.literal('')),
    metodoPagoPrevisto: z.enum(METODOS_PAGO),
    observaciones: z.string().max(4000).optional().or(z.literal('')),
});
